<style lang="scss">
.payment-kiosk-items {
  .detail-item {
    display: flex;
    justify-content: space-between;
  }

  .kiosk-item-row {
    border: 1px solid #ebe9f1;
    border-left: none;
    border-right: none;
    padding: 10px 0;

    &:nth-child(2) {
      border-top: none;
    }
  }
}
</style>

<!-- eslint-disable -->
<template>
  <b-card class="payment-kiosk-items">
    <b-card-title class="d-flex align-items-center">
      Payments and Kiosk Items
      <div class="ui-spacer" />
      <b-btn
        v-if="showRefundKioskItemsButtons"
        size="sm"
        variant="warning"
        @click="showRefundModal"
      >
        Refund items
      </b-btn>
    </b-card-title>

    <section class="mb-2" v-if="call.kiosk_items && call.kiosk_items.length > 0">
      <h5 class="mb-2">Kiosk Items</h5>
      <div v-for="kioskItem in call.kiosk_items" :key="kioskItem.kiosk_item_id" class="kiosk-item-row d-flex justify-content-between">
        <p class="mb-0" cy="item-name">{{kioskItem.name}}</p>
        <p class="mb-0">
          <span class="badge badge-success badge-pill mr5" cy="item-amount">{{kioskItem.amount}} x {{$options.filters.regionCurrency()}}{{kioskItem.price.toFixed(2)}}</span>
          <span class="badge badge-primary badge-pill" cy="item-price">Total: {{$options.filters.regionCurrency()}}{{(kioskItem.amount * kioskItem.price).toFixed(2)}}</span>
          <span v-if="kioskItem.amount_refunded > 0" class="badge badge-warning badge-pill ml-1">
            Refunded: {{ kioskItem.amount_refunded }} items ({{$options.filters.regionCurrency()}}{{(kioskItem.amount_refunded * kioskItem.price).toFixed(2)}})
          </span>
        </p>
      </div>
    </section>

    <section>
      <p class="detail-item mb-0 sm-row-drop" cy="kiosk-total">Kiosk Total: <b>{{$options.filters.regionCurrency()}}{{getTotalOfKioskItems()}}</b></p>
      <p class="detail-item mb-0 sm-row-drop" cy="call-base-cost">Call Base Cost: <b>{{$options.filters.regionCurrency()}}{{getVisitBaseCost()}}</b></p>
      <p class="detail-item mb-0 sm-row-drop" cy="call-total-cost">Total: <b>{{$options.filters.regionCurrency()}}{{getVisitTotalCost()}}</b></p>
    </section>

    <refund-kiosk-items-modal
      :call-id="call._id"
      :kiosk-items="call.kiosk_items"
      @close="closeModal"
    />
  </b-card>
</template>
<!-- eslint-enable -->

<script>
  import {mapState} from 'vuex';
  import RefundKioskItemsModal from '@/components/modals/RefundKioskItemsModal.vue';

  export default {
    name: 'PaymentAndKioskItems',
    components: { RefundKioskItemsModal },
    props: {},
    data() {
      return {
        test: '',
      };
    },
    computed: {
      ...mapState({
        prison: state => state.prison.prison,
        call: state => state.callDetails.call,
      }),
      showRefundKioskItemsButtons() {
        if (this.call.status !== 'Completed') {
          return false;
        }

        if (!this.call.kiosk_items || this.call.kiosk_items.length <= 0) {
          return false;
        }

        const refundAlreadyProcessed = this.call.kiosk_items.some(item => {
          const refunded = item.amount_refunded === null ? 0 : item.amount_refunded;
          return refunded > 0;
        });

        return !refundAlreadyProcessed;
      },
      hasRefundedKioskItems() {
        return this.call.kiosk_items.some(item => item.amount_refunded > 0);
      },
    },
    mounted() {

    },
    methods: {
      getTotalOfKioskItems() {
        if(this.call.kiosk_items && this.call.kiosk_items.length > 0) {
          let total = 0;
          this.call.kiosk_items.forEach((kioskItem) => {
            total += (kioskItem.amount * kioskItem.price);
          });
          return total.toFixed(2);
        }
        return '0';
      },
      getVisitBaseCost() {
        if(this.call.is_funded) {
          return '0 (Funded Video call)';
        }
        return this.call.base_cost.toFixed(2);
      },
      getVisitTotalCost() {
        let kioskItemTotal = 0;
        let visitCostTotal = this.call.base_cost;
        if(this.call.is_funded) {
          visitCostTotal = 0;
        }
        if(this.call.kiosk_items && this.call.kiosk_items.length > 0) {
          this.call.kiosk_items.forEach((kioskItem) => {
            kioskItemTotal += (kioskItem.amount * kioskItem.price);
          });
        }
        return (kioskItemTotal + visitCostTotal).toFixed(2);
      },
      showRefundModal() {
        this.$bvModal.show('refund-kiosk-modal');
      },
      closeModal() {
        this.$bvModal.hide('refund-kiosk-modal');
      },
    },
  };
</script>
